<h1 mat-dialog-title>Uwaga!</h1>
<p>Czy chciałbyś zostać przeniesiony do pliku kwaterunkowego aby ustawić dostępność pokoi?</p>
<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" class="button-dismiss" (click)="closeDialog()">Nie</button>
	<button mat-raised-button color="primary" class="button-accept" (click)="redirect()">Tak</button>
</mat-dialog-actions>
